import { router } from 'expo-router';
import * as React from 'react';
import {
    BodyMediumRegular,
    ChevronDownIcon,
    Icon,
    LabelRegular,
    XStack,
    YStack,
} from 'smoothie';

import {
    IncomeSplitRuleContributionType,
    IncomeSplitRuleContributionTypeNames,
} from '../../../types/IncomeSplit';
import PaycheckRoutingCard from '../../paycheck-routing/common/PaycheckRoutingCard';

interface RuleTypeProps {
    percentage?: number | null;
}

const RuleEditorContributionType = ({ percentage }: RuleTypeProps) => {
    return (
        <YStack gap={8}>
            <LabelRegular marginLeft={8} color="$gray1100">
                Contribution type
            </LabelRegular>
            <PaycheckRoutingCard
                onPress={() => {
                    router.navigate('/income-split/edit/contribution-type');
                }}
            >
                <XStack justifyContent="space-between" alignItems="center">
                    <BodyMediumRegular color="$black">
                        {percentage == null
                            ? IncomeSplitRuleContributionTypeNames[
                                  IncomeSplitRuleContributionType
                                      .MAXIMIZE_CONTRIBUTIONS
                              ]
                            : IncomeSplitRuleContributionTypeNames[
                                  IncomeSplitRuleContributionType
                                      .PERCENTAGE_OF_REMAINDER
                              ]}
                    </BodyMediumRegular>
                    <Icon icon={ChevronDownIcon} color="$gray1000" />
                </XStack>
            </PaycheckRoutingCard>
        </YStack>
    );
};

export default RuleEditorContributionType;
